<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<el-form :inline="true" :model="formInline" class="user-search">
				<el-form-item label="所属门店：">
					<el-select v-model="formInline.storeKeyId" placeholder="请选择门店" clearable filterable size="small" @change="inputChange">
						<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="商品类型：">
					<el-select v-model="formInline.typeName" placeholder="请选择商品类型" clearable filterable size="small" @change="handleTypeNameChange">
						<el-option v-for="item in typeNameList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="商品系列：">
					<el-select v-model="formInline.productName" placeholder="请选择商品系列" clearable filterable size="small" @change="handleProductNameChange">
						<el-option v-for="item in productNameList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="商品名称：">
					<el-input v-model="formInline.specification" placeholder="请输入商品名称" clearable size="small" @change="inputChange"></el-input>
				</el-form-item>
				<el-form-item label="是否有库存：">
					<el-select v-model="formInline.isHasQty" placeholder="请选择是否有库存" size="small">
						<el-option label="全部" :value="null"></el-option>
						<el-option label="是" :value="true"></el-option>
						<el-option label="否" :value="false"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="是否真实库存：">
					<el-select v-model="formInline.isWareHouse" placeholder="请选择是否真实库存" size="small">
						<el-option label="全部" :value="null"></el-option>
						<el-option label="是" :value="true"></el-option>
						<el-option label="否" :value="false"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button v-if="$checkBtnPermission('/storeProduct/index', 'viewPage')" size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
					<el-button v-if="$checkBtnPermission('/storeProduct/index', 'monthCheck')" size="small" type="warning" class="el-icon-refresh" @click="handleMonthCheck()">本月盘点</el-button>
					<el-button v-if="$checkBtnPermission('/storeProduct/index', 'preMonthCheck')" size="small" type="danger" class="el-icon-refresh" @click="handlePreMonthCheck()">上月盘点</el-button>
					<el-button v-if="btnPermission.transfer" size="mini" icon="el-icon-refresh" type="primary" @click="handleTransfer()">调拨</el-button>
					<el-button v-if="btnPermission.editQty" size="mini" icon="el-icon-edit" type="primary" @click="handleEditQty()">修改库存数量</el-button>
				</el-form-item>
			</el-form>
			<STable :columns="columnsData" :data="listData" :loading="loading" row-key="keyId" height="520" @selection-change="handleSelectionChange">
				<el-table-column slot="productInfo.code" label="商品编码" min-width="200" align="center">
					<template #default="scope">
						<el-link type="primary" :underline="false" @click="handleShowHistory(scope.row)">
							{{ scope.row.productInfo.code }}
						</el-link>
					</template>
				</el-table-column>
				<template #quantity>
					<el-table-column label="库存数量" min-width="120" align="center">
						<template #default="scope">
							<span v-if="scope.row.productInfo.isWareHouse">{{ scope.row.quantity }}</span>
							<span v-else>--</span>
						</template>
					</el-table-column>
				</template>
				<template #operation>
					<el-table-column label="操作" min-width="200" align="center" fixed="right">
						<template #default="scope">
							<el-button v-if="btnPermission.createInputStoreProduct" size="mini" icon="el-icon-plus" type="primary" @click="handleCreateInputStoreProduct(scope.row)">创建入库单</el-button>
						</template>
					</el-table-column>
				</template>
			</STable>
			<!-- 分页组件 -->
			<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
		</topTab>
		<!-- 历史记录 -->
		<history ref="history"></history>
		<!-- 创建入库单 -->
		<inputStoreProductCreate ref="inputStoreProductCreate"></inputStoreProductCreate>
		<!-- 调拨 -->
		<transfer ref="transfer"></transfer>
		<!-- 修改库存数量 -->
		<editQty ref="editQty"></editQty>
	</div>
</template>

<script>
import { GetStoreProductPageList, BatchCreateMonthStoreProduct, GetProductTypeNameList, GetProductTypeSubNameList } from "@/api/productApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
import history from "./history.vue";
import inputStoreProductCreate from "@/views/product/input/create.vue";
import transfer from "@/views/product/store/transfer.vue";
import editQty from "@/views/product/store/editQty.vue";
export default {
	data() {
		return {
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "门店库存"
				}
			],
			pageShow: true,
			loading: false, // 显示加载
			listData: [],
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				storeKeyId: "",
				typeName: "",
				productName: "",
				specification: "",
				isHasQty: null,
				isWareHouse: null
			},
			storeList: [],
			columnsData: [], //显示列
			listColumns: [
				{
					prop: "keyId",
					label: "全选",
					align: "center",
					width: "55",
					isKeep: true,
					selection: true
				},
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "80",
					isKeep: true
				},
				{
					prop: "storeName",
					label: "门店名称",
					isKeep: true,
					minWidth: "120",
					align: "center",
				},
				{
					slot: "productInfo.code",
					label: "商品编码",
					isKeep: true,
					minWidth: "170",
					align: "center",
				},
				{
					prop: "productInfo.typeName",
					label: "类型",
					width: "120",
					align: "center"
				},
				{
					prop: "productInfo.productName",
					label: "系列",
					width: "180",
					align: "center"
				},
				{
					prop: "productInfo.specification",
					label: "商品名称",
					width: "150",
					align: "center"
				},
				{
					prop: "price",
					label: "价格(元)",
					width: "120",
					align: "center",
					isMoney: true,
					moneyType: "normal"
				},
				{
					slot: "quantity",
					label: "库存数量",
					width: "120",
					align: "center"
				},
				{
					prop: "productInfo.unit",
					label: "单位",
					width: "120",
					align: "center"
				},
				{
					prop: "creator",
					label: "创建人",
					width: "120",
					align: "center"
				},
				{
					prop: "createTime",
					label: "创建时间",
					width: "170",
					align: "center"
				},
				{
					prop: "editor",
					label: "维护人",
					width: "120",
					align: "center"
				},
				{
					prop: "updateTime",
					label: "维护时间",
					width: "170",
					align: "center"
				},
				{
					slot: "operation",
					label: "操作",
					width: "170",
					align: "center"
				}
			],
			btnPermission: {
				createInputStoreProduct: false,
				transfer: false,
				editQty: false
			},
			// 商品类型名称列表
			typeNameList: [],
			// 商品类型子名称列表
			productNameList: [],
			// 选中的行
			selectedRows: []
		};
	},
	// 注册组件
	components: {
		history,
		inputStoreProductCreate,
		transfer,
		editQty
	},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));
		this.GetOrgInfoListByConfig();
		// 检查按钮权限
		this.checkBtnPermission();
		// 获取商品类型名称列表
		this.getProductTypeNameList();
		// 获取商品类型子名称列表
		this.getProductTypeSubNameList("");
	},
	computed: {},
	methods: {
		// 检查按钮权限
		checkBtnPermission() {
			this.btnPermission.createInputStoreProduct = this.$checkBtnPermission("/productInput/index", "create");
			this.btnPermission.transfer = this.$checkBtnPermission("/storeProduct/index", "transfer");
			this.btnPermission.editQty = this.$checkBtnPermission("/storeProduct/index", "editQty");
		},
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		changePages() {},
		// 获取所属门店
		GetOrgInfoListByConfig() {
			const paramer = {
				key: 1
			};
			GetOrgInfoListByConfig(paramer)
				.then((res) => {
					this.storeList = [];
					if (res.code == 1) {
						res.data.forEach((item) => {
							this.storeList.push({
								keyId: item.keyId,
								value: item.name + "【" + item.remark2 + "】"
							});
						});
						this.formInline.storeKeyId = this.storeList[0].keyId;
						this.getListData();
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取门店信息失败!");
				});
		},
		// 获取列表
		getListData() {
			this.loading = true;
			GetStoreProductPageList(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.loading = false;
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		inputChange(val) {
			this.search();
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},
		handleShowHistory(row) {
			this.$refs.history.showRecordDialog(row);
		},
		// 创建入库单
		handleCreateInputStoreProduct(row) {
			// 检查是否选择了商品
			if (!row.keyId) {
				this.$message.error("请先选择商品111！");
				return;
			}
			this.$refs.inputStoreProductCreate.editShow(row);
		},
		// 本月盘点
		handleMonthCheck() {
			const paramer = {
				storeKeyId: this.formInline.storeKeyId,
				type: 2
			};
			// 检查是否选择了门店
			if (!this.formInline.storeKeyId) {
				this.$message.error("请先选择门店！");
				return;
			}
			this.loading = true;
			BatchCreateMonthStoreProduct(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.$message({
							type: "success",
							message: "本月盘点成功！"
						});
						this.getListData();
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.$message.error("本月盘点失败，请稍后再试！");
				})
				.finally(() => {
					this.loading = false;
				});
		},
		// 上月盘点
		handlePreMonthCheck() {
			const paramer = {
				storeKeyId: this.formInline.storeKeyId,
				type: 1
			};
			// 检查是否选择了门店
			if (!this.formInline.storeKeyId) {
				this.$message.error("请先选择门店！");
				return;
			}
			this.loading = true;
			BatchCreateMonthStoreProduct(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.$message({
							type: "success",
							message: "上月盘点成功！"
						});
						this.getListData();
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.$message.error("上月盘点失败，请稍后再试！");
				})
				.finally(() => {
					this.loading = false;
				});
		},
		// 处理类型名称改变
		handleTypeNameChange(val) {
			this.formInline.productName = "";
			this.getProductTypeSubNameList(val);
			this.getListData();
		},
		// 处理商品名称改变
		handleProductNameChange(val) {
			this.formInline.productName = val;
			this.getListData();
		},
		getProductTypeNameList() {
			GetProductTypeNameList({}).then((res) => {
				if (res.code == 1) {
					this.typeNameList = [];
					if (res.code == 1) {
						res.data.forEach((item) => {
							this.typeNameList.push({
								keyId: item.value,
								value: item.value
							});
						});
					} else {
						this.$message.error(res.msg);
					}
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		getProductTypeSubNameList(code) {
			var params = {
				code: code
			};
			GetProductTypeSubNameList(params).then((res) => {
				if (res.code == 1) {
					this.productNameList = [];
					if (res.code == 1) {
						res.data.forEach((item) => {
							this.productNameList.push({
								keyId: item.value,
								value: item.value
							});
						});
					} else {
						this.$message.error(res.msg);
					}
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		// 调拨
		handleTransfer() {
			// 检查是否选择了商品
			if (this.selectedRows.length == 0) {
				this.$message.error("请先选择商品！");
				return;
			}
			// 检查是否选择了门店
			if (!this.formInline.storeKeyId) {
				this.$message.error("请先选择门店！");
				return;
			}
			this.$refs.transfer.showTransferDialog(this.selectedRows, this.formInline.storeKeyId);
		},
		handleSelectionChange(selection) {
			this.selectedRows = selection;
		},
		//清理调拨选中的商品信息
		clearSelectedGoods() {
			this.selectedRows = [];
		},
		// 修改库存数量
		handleEditQty() {
			// 检查是否选择了商品
			if (this.selectedRows.length == 0) {
				this.$message.error("请先选择商品！");
				return;
			}
			this.$refs.editQty.showEditQtyDialog(this.selectedRows);
		}
	}
};
</script>

<style scoped></style>
